/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FaceScan/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FaceScan({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FaceScan",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FaceScan.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z1McpNt': alignSelf,'--mt-2-Z1McpNt': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1McpNt': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1McpNt': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1McpNt': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1McpNt': opacity,'--w-10-Z1McpNt': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1McpNt': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1McpNt': fill,'--a-7-Z1McpNt': isAnimated ? animation : "none",'--sd-8-Z1McpNt': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1McpNt': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FaceScan.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.5 1.286a.214.214 0 00-.214.214v1.286a.643.643 0 11-1.286 0V1.5A1.5 1.5 0 011.5 0h1.286a.643.643 0 110 1.286H1.5zm9.857 7.285c.355 0 .643.288.643.643V10.5a1.5 1.5 0 01-1.5 1.5H9.214a.643.643 0 010-1.286H10.5a.214.214 0 00.214-.214V9.214c0-.355.288-.643.643-.643zm-10.071.643a.643.643 0 00-1.286 0V10.5A1.5 1.5 0 001.5 12h1.286a.643.643 0 100-1.286H1.5a.214.214 0 01-.214-.214V9.214zM8.57.643c0-.355.288-.643.643-.643H10.5A1.5 1.5 0 0112 1.5v1.286a.643.643 0 11-1.286 0V1.5a.214.214 0 00-.214-.214H9.214a.643.643 0 01-.643-.643zM6 1.82a4.196 4.196 0 100 8.392 4.196 4.196 0 000-8.392zm1.636 4.79a.536.536 0 01.235.72l-.477-.242.477.242v.003l-.002.002-.003.006-.009.015a1.142 1.142 0 01-.108.164c-.072.095-.179.216-.328.335-.306.244-.77.465-1.421.465-.65 0-1.115-.221-1.42-.465a1.891 1.891 0 01-.413-.457 1.16 1.16 0 01-.024-.042l-.009-.015-.003-.006-.001-.002v-.002l.476-.243-.477.242a.536.536 0 01.95-.495v.002a.82.82 0 00.167.18c.133.105.365.232.754.232s.621-.127.753-.232a.82.82 0 00.167-.18l.001-.002a.536.536 0 01.715-.225zM4.374 4.393a.643.643 0 110 1.286.643.643 0 010-1.286zm3.252 0a.643.643 0 110 1.286.643.643 0 010-1.286z"
 style={{'--f-12-Z1McpNt': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}